import React, {useState, useEffect} from 'react'
import {
LinkIcon,
} from '../RentWearable/rentWearableStyles'

import { 
  Dash2,
  Wrapper2,
  Left2,
  DashLogo2,
  LeftCaption2,
  Link2,
  ProfileInfo,
  WalletAddress,
  DashIcons2,
  Right2,
  DashIconContainer2, 
  UserIcon,
  UserIconContainer,
} from '../../components/dashboardBar2/dashboardBar2Styles'

import {
Page17Card,
Page17CardFirstPart,
Page17CardFirstPartText,
Page17CardSecondPart,
Page17CardsWrapper,
Page17Container,
Page17Head,
Page17HeadCaption,
Page17Wrapper
} from './FAQStyles'
import WalletConnect from '../../components/ConnectionNav/Connect'
import { useTranslation } from 'react-i18next'
import image from '../../icons/dashboardBarIcons/BlueLogo.png'
import ProfileCard from '../../components/PopUps/profileCard/ProfileCard'
import ResponsiveDashBar from '../../components/ResponsiveBar/ResponsiveDashBar';
import profilePicture from '../../assets/Image.svg'
import styled from 'styled-components'
import Discord from '../../assets/Disocrd'
import Rentals from '../../icons/dashboardBarIcons/Rentals'
import Message from '../../icons/dashboardBarIcons/Message'
import EmailPopup from '../../components/PopUps/EmailPopup/EmailPopup'
import RentalsPopup from '../../components/PopUps/RentalsPopup/RentalsPopup'
import NotificationIcon from '../../icons/dashboardBarIcons/NotificationIcon.js'
import Notifications from '../../components/PopUps/NotiicationDropDown/NotificationDropDown';


export const Page17CardsContainer = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 20px;
    margin-top: 20px;
    padding: 0px 100px;
    background-color:black;

    @media screen and (max-width: 950px){
    padding: 0px 20px;
  }

  @media screen and (max-width: 500px){
    display:flex;
    flex-direction:column;
  }



`
export const DiscordContainer = styled.div`
    width:260px;
    background-color:#262626;
    border-radius:10px;
    max-height:200px;
    display:flex;

    @media screen and (max-width: 500px){
    margin-top: 20px;
  }



`
export const DiscordWrapper = styled.div`
    margin: 10px 20px 0px 20px;
    justify-content:center;
    width: inherit;
    height:inherit;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    
`
export const DiscordImage = styled.img`
    width:80px;
    height:70px;
    
    & > svg > path{
        fill: white;
    }
    
    
`
export const DiscordButton = styled.button`
    background-color:black;
    color:white;
    width:200px;
    border: none;
    border-radius: 10px;
    margin-top:44px;
    padding:10px 14px;
`


const Page17 = () => {
    const { t } = useTranslation();
    const [degree , setDegree] = useState('100%');
    const [profileDisplay, setProfileDisplay] = useState('none');
    const [messageDisplay, setMessageDisplay] = useState('none');
    const [rentalsDisplay, setRentalsDisplay] = useState('none');
    const [notificationDisplay, setNotificationDisplay] = useState('none');


    const ProfileClick = () => {
        if(profileDisplay === 'none'){
          setProfileDisplay('flex');
          setDegree('50%');
        }else{
          setDegree('100%');
          setProfileDisplay('none');
        }
      }
      const NotificationIconClick = () => {
        if(notificationDisplay === 'none'){
          setNotificationDisplay('flex');
          setDegree('50%');
        }else{
          setNotificationDisplay('none');
          setDegree('100%');
        }
      }
    
      const MessageClick = () => {
        if(messageDisplay === 'none'){
          setMessageDisplay('flex');
          setDegree('50%');
        }else{
          setDegree('100%');
          setMessageDisplay('none');
        }
      }
    
      const RentalClick = () =>{
        if(rentalsDisplay === 'none'){
          setRentalsDisplay('flex');
          setDegree('50%');
        }else{
          setDegree('100%');
          setRentalsDisplay('none');
        }
      }
    

    const CancelMessage = () => {
      setMessageDisplay('none');
      setDegree('100%')
    }


    const Clear = () => {
      setDegree('100%')
      setProfileDisplay('none');
      setMessageDisplay('none');
      setRentalsDisplay('none');
      setNotificationDisplay('none')
    }

    useEffect(() =>{
        const container = document.querySelector('#container')
        if(degree === '50%'){
          container.addEventListener('click', Clear );
          console.log(degree);
        }else if(degree === '100%'){
          container.removeEventListener('click', Clear);
          console.log(degree);
        }
      })

    


  return (
    <>
        <Page17Container id='container' degree={degree} >
        <WalletConnect />

            <Dash2>

                <Wrapper2>
                <Left2>
                    <DashLogo2 src={image} />
                    <LeftCaption2>
                    <Link2>
                    {t("page17.pageName")}
                    </Link2>
                    </LeftCaption2>
                </Left2>
                <Right2>
                <ResponsiveDashBar />
                    <ProfileInfo>
                        <WalletAddress>Mpzi8uaA......yMv</WalletAddress>
                        {t("page5.profileCard.connected")}
                    </ProfileInfo>

                    <DashIcons2>
                    <LinkIcon onClick={ProfileClick}>
                        <UserIconContainer>
                            <UserIcon src={profilePicture} />
                        </UserIconContainer>
                    </LinkIcon>
                    <LinkIcon onClick={RentalClick}>
                        <DashIconContainer2>
                            <Rentals />
                        </DashIconContainer2>
                    </LinkIcon>
                    <LinkIcon onClick={MessageClick}>
                        <DashIconContainer2>
                            <Message />
                        </DashIconContainer2>
                    </LinkIcon>
                    <LinkIcon onClick={NotificationIconClick}>
                        <NotificationIcon />
                      </LinkIcon>
                    </DashIcons2>
                    </Right2>
                </Wrapper2>
                </Dash2>


            <Page17Wrapper>
                <Page17Head>
                    <Page17HeadCaption>
                        {t("page17.caption")}
                    </Page17HeadCaption>
                </Page17Head>
            </Page17Wrapper>


            <Page17CardsContainer>

                <Page17CardsWrapper>
                    <Page17Card>                    
                            <Page17CardFirstPart>
                                <Page17CardFirstPartText>{t("page17.cards.card1.qns")}</Page17CardFirstPartText>
                            </Page17CardFirstPart>
                        <Page17CardSecondPart>{t("page17.cards.card1.ans")}</Page17CardSecondPart>
                    </Page17Card>
                    <Page17Card>                    
                            <Page17CardFirstPart>
                                <Page17CardFirstPartText>{t("page17.cards.card2.qns")}</Page17CardFirstPartText>
                            </Page17CardFirstPart>
                        <Page17CardSecondPart>{t("page17.cards.card2.ans")}</Page17CardSecondPart>
                    </Page17Card>
                    <Page17Card>                    
                            <Page17CardFirstPart>
                                <Page17CardFirstPartText>{t("page17.cards.card3.qns")}</Page17CardFirstPartText>
                            </Page17CardFirstPart>
                        <Page17CardSecondPart>{t("page17.cards.card3.ans")}</Page17CardSecondPart>
                    </Page17Card>
                    <Page17Card>                    
                            <Page17CardFirstPart>
                                <Page17CardFirstPartText>{t("page17.cards.card4.qns")}</Page17CardFirstPartText>
                            </Page17CardFirstPart>
                        <Page17CardSecondPart>{t("page17.cards.card4.ans")}</Page17CardSecondPart>
                    </Page17Card>
                    <Page17Card>                    
                            <Page17CardFirstPart>
                                <Page17CardFirstPartText>{t("page17.cards.card5.qns")}</Page17CardFirstPartText>
                            </Page17CardFirstPart>
                        <Page17CardSecondPart>{t("page17.cards.card5.ans")}</Page17CardSecondPart>
                    </Page17Card>
                    <Page17Card>                    
                            <Page17CardFirstPart>
                                <Page17CardFirstPartText>{t("page17.cards.card6.qns")}</Page17CardFirstPartText>
                            </Page17CardFirstPart>
                        <Page17CardSecondPart>{t("page17.cards.card6.ans")}</Page17CardSecondPart>
                    </Page17Card>
                </Page17CardsWrapper>

                <DiscordContainer>
                    <DiscordWrapper>
                        <Discord />
                        <DiscordButton>{t("page17.discord")}</DiscordButton>
                    </DiscordWrapper>
                </DiscordContainer>

            </Page17CardsContainer>



        </Page17Container>



    <ProfileCard display={profileDisplay}/>
    <EmailPopup display= {messageDisplay} Cancel={CancelMessage}/>
    <RentalsPopup display = {rentalsDisplay}/>
    <Notifications display={notificationDisplay} />
    </>
  )
}

export default Page17